import http from "../AppConfig";
import {Encrypt} from "@/plugins/cryptojs";

const groupName = window.location.hostname.slice(
    0,
    window.location.hostname.indexOf(".", 0)
);

const c = encodeURIComponent(Encrypt(groupName));

class FormSettingService {
  getFormSettingByType(type, hash) {
    return http.get(`screens?type=${type}&hash=${hash}&c=${c}`);
  }

  saveEntryForm(formSettings, hash, token) {
    return http.post(`screens/entry-forms?hash=${hash}&c=${c}`, formSettings, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  }

  saveJobSearchForm(formSettings, hash, token) {
    return http.post(`screens/job-search-forms?hash=${hash}&c=${c}`, formSettings, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  }

  saveJobDetailForm(formSettings, hash, token) {
    return http.post(`screens/job-detail-forms?hash=${hash}&c=${c}`, formSettings, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  }

  saveJobListForm(formSettings, hash, token) {
    return http.post(`screens/job-list-forms?hash=${hash}&c=${c}`, formSettings, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  }

  updateTimeItemDeleted(itemIds, hash, token) {
    return http.post(`screens/update-item-deleted?hash=${hash}&c=${c}`, itemIds, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  }

  updateTimeItemHeadingBodyDeleted(itemIds, hash, token) {
    return http.post(
      `screens/update-item-heading-body-deleted?hash=${hash}&c=${c}`,
      itemIds,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
  }

  updateTimeUserMailSettingDeleted(userMailSetting, hash, token) {
    return http.post(
      `screens/update-time-user-deleted?hash=${hash}&c=${c}`,
      userMailSetting,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
  }
}

export default new FormSettingService();
